import axios from "axios";
import * as api from "../server/api";

export const LOGIN_REQUEST = "AR/ACCOUNT/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "AR/ACCOUNT/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "AR/ACCOUNT/LOGIN_FAILURE";

export const GET_ALL_ADMIN_USERS_REQUEST = "AR/ACCOUNT/GET_ALL_ADMIN_USERS_REQUEST";
export const GET_ALL_ADMIN_USERS_SUCCESS = "AR/ACCOUNT/GET_ALL_ADMIN_USERS_SUCCESS";
export const GET_ALL_ADMIN_USERS_FAILURE = "AR/ACCOUNT/GET_ALL_ADMIN_USERS_FAILURE";

export const UPDATE_USER_REQUEST = "AR/ACCOUNT/UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "AR/ACCOUNT/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "AR/ACCOUNT/UPDATE_USER_FAILURE";

export const LOGOUT = "AR/ACCOUNT/LOGOUT";

const initialState = {
  loading: false,
  error: false,
  data: {
    jwt: null,
    user: null,
  },
  admins: []
};

export default function reducersAccount(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loading: true };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case LOGIN_FAILURE:
      return { ...state, loading: false, data: initialState.data, error: action.error };
    case GET_ALL_ADMIN_USERS_REQUEST:
      return { ...state, loading: true };
    case GET_ALL_ADMIN_USERS_SUCCESS:
      return { ...state, loading: false, admins: action.payload, error: null };
    case GET_ALL_ADMIN_USERS_FAILURE:
      return { ...state, loading: false, admins: initialState.admins, error: action.error };
    case UPDATE_USER_REQUEST:
      return { ...state, loading: true };
    case UPDATE_USER_SUCCESS:
      return { ...state, loading: false, error: null };
    case UPDATE_USER_FAILURE:
      return { ...state, loading: false, error: action.error };
    case LOGOUT:
      return { ...state, loading: false, data: initialState.data, error: null };
    default:
      return state;
  }
}

export const login = (credentials) => {
  return async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    try {
      if (!credentials) {
        const lsUser = JSON.parse(localStorage.getItem("user"));
        const jwt = localStorage.getItem("jwt");

        if (lsUser) {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: {
              jwt,
              user: lsUser,
            },
          });
        } else {
          dispatch({
            type: LOGIN_FAILURE,
            error: "no_user_in_local_storage",
          });
        }
      } else {
        const { url, method, data } = api.login(credentials);
        const results = await axios({
          url,
          method,
          data,
        });

        if (results.status === 200) {
          const { data } = results;

          // console.log(data);
          if (
            (data.user.role.type === "admingestionale" ||
              data.user.role.type === "supervisorgestionale" ||
              data.user.role.type === "usergestionale") &&
            data.user.confirmed &&
            !data.user.blocked
          ) {
            dispatch({ type: LOGIN_SUCCESS, payload: data });

            localStorage.setItem("jwt", data.jwt);
            localStorage.setItem("user", JSON.stringify(data.user));
          } else {
            dispatch({ type: LOGIN_FAILURE, error: results.status });
          }
        } else {
          dispatch({ type: LOGIN_FAILURE, payload: results.status });
        }
      }
    } catch (e) {
      console.log("err", e);
      dispatch({ type: LOGIN_FAILURE, error: e });
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch({ type: LOGOUT });
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
  };
};

export const getAllAdminUsers = () => {
  return async (dispatch) => {
    dispatch({type: GET_ALL_ADMIN_USERS_REQUEST})
    try {
      const {url, method, data} = api.getAllAdminUsers()
      const result = await axios({url, method, data})

      // console.log('res', result)
      dispatch({
        type: GET_ALL_ADMIN_USERS_SUCCESS,
        payload: result.data.data.users
      })

    } catch (err) {
      console.log(err)
      dispatch({type: GET_ALL_ADMIN_USERS_FAILURE, payload: err})
    }
  }
}

export const updateUser = (userId, credentials) => {
  return async (dispatch) => {
    dispatch({type: UPDATE_USER_REQUEST})
    try {
      const {url, method, data} = api.updateUser(userId, credentials.email, credentials.password)
      const result = await axios({url, method, data})

      // console.log('res', result)
      dispatch({
        type: UPDATE_USER_SUCCESS,
      })

    } catch (err) {
      console.log(err)
      dispatch({type: UPDATE_USER_FAILURE, payload: err})
    }
  }
}
